import { useContext } from 'react';
import { SummaryContext } from './summaryContext';

export const useShouldSummaryItemRender = (label: string, tab?: string): boolean => {
  const { activeTab, filterText } = useContext(SummaryContext);
  if (activeTab && activeTab?.label !== tab) {
    // don't render another tab's summary items
    return false;
  }
  if (activeTab?.callback) {
    return activeTab.callback(filterText, label);
  }
  return label.toLowerCase().includes(filterText.toLowerCase());
};
